import React from 'react';

const Footer = () => {
    return (
        <div>
            <p>copyright</p>
        </div>
    );
};

export default Footer;